var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_vm._v("\n  "+_vm._s(_vm.info)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }